import { isInViewport } from "./utils";

export function animation() {
  document.body.classList.add("js");

  const blocks = document.querySelectorAll("[data-animation]");
  init(blocks);
  animation(blocks);

  window.addEventListener(
    "scroll",
    function () {
      animation(blocks);
    },
    false
  );
  function init(blocks) {
    blocks.forEach(function (block) {
      let dataType = block.dataset.animation;
      if (dataType == "group") {
        let children = block.querySelectorAll(":scope > div");
        let sec = 0;
        children.forEach(function (child) {
          child.style.setProperty("--delay", sec + "s");
          sec += 0.2;
        });
      }
    });
  }

  function animation(blocks) {
    blocks.forEach(function (block) {
      if (isInViewport(block) && !block.classList.contains("animated")) {
        block.classList.add("animated");
      }
    });
  }
}
